export enum ProjectClassification {
    INITIAL = 'initial',
    RED = 'red',
    ORANGE = 'orange',
    GREEN = 'green',
}
